
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Tarina',
	'noDashboardFound': 'Tarinan nouto ei onnistu. Sitä ei enää ole, tai sinulla ei ole sen tarkasteluoikeuksia.',
	'noDashboardCapability': 'Sinulla ei ole valtuuksia käyttää tarinoita',
	'noDashboardPermision': 'Käyttöoikeutesi eivät riitä tämän tarinan tarkasteluun.',
	'defaultName': 'Uusi tarina',
	'storyProperties': 'Tarinaominaisuudet',
	'createAvDataStoryLabel': 'Tarina',
	'createAvSlideShowLabel': 'Diaesitys',
	'createAvPanAndZoomLabel': 'Opastettu matka',
	'dashboard_save_success': 'Tarina on tallennettu.',
	'cmEmptySelection': 'Tarina on poistettu. Yritä tallentaa uutena tarinana.',
	'createStoryTitle': 'Luo tarina',
	'transitionStyleTitle': 'Siirtymä tyyli',
	'createButton': 'Luo',
	'cancelButton': 'Peruuta',
	'dashboardResetTitle': 'Palauta tarina',
	'dashboardResetMessage': 'Haluatko varmasti palauttaa kaikki tämän tarinan muutokset?',
	'dashboardResetToast': 'Tarina on palautettu.',
	'filter_drag_and_drop_all_tabs': 'Voit suodattaa kaikki kohtaukset vetämällä ja pudottamalla tietoja tähän.',
	'filter_drag_and_drop_current_tab': 'Voit suodattaa tämän kohtauksen vetämällä ja pudottamalla tietoja tähän.',
	'filterIconLabel_Global': 'Kaikki kohtaukset',
	'filterIconLabel_Tab': 'Tämä kohtaus',
	'filterIconTooltip_Global': 'Kaikki kohtaukset',
	'filterIconTooltip_Tab': 'Tämä kohtaus',
	'filterOverflowMenu_Global': 'Kaikkien kohtausten ylivuotovalikko',
	'filterOverflowMenu_Tab': 'Tämän kohtauksen ylivuotovalikko',
	'renameScene': 'Nimeä kohtaus uudelleen',
	'duplicateScene': 'Kohtaus on kaksoiskappale',
	'deleteScene': 'Poista kohtaus',
	'editTimelineHighlight': 'Muokkaa korostusta',
	'deleteTimelineHighlight': 'Poista korostus',
	'filter_includesAll': 'Sisältää kaikki',
	'timeline_highlight_moved_to': 'Aikajanan korostus %{id} on siirretty aikaan %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Valitse',
	'newDefaultStoryName': 'Tarina: %{modelName}',
	'exportLabel': 'Tallenna',
	'exportAsLabel': 'Tallenna nimellä:',
	'exportDialogTitle': 'Tallenna tarinana',
	'exportDialogFooter': 'Tallennus- ja peruutuspainikkeet',
	'loadAfterExportLabel': 'Avaa tarina tallennuksen jälkeen',
	'selectTemplateLabel': 'Valitse malli',
	'outOfBoundsWarningMessage': 'Osa mittatietotaulu-widget-objekteista on ruudukon ulkopuolella, eivätkä ne kenties näy oikein viennin jälkeen.',
	'emptyExploreCardsWarningMessage': 'Tyhjät kortit poistettiin tallennettaessa tarinana.',
	'dashboard_export_success': 'Mittatietotaulu tallennettiin tarinana.',
	'explore_export_success': 'Tutkimus tallennettiin tarinana.',
	'toastUpgradeDone': 'Tarina on päivitetty. Tallenna nyt, jotta optimaalinen suorituskyky säilyy.',
	'navigationMarker': 'Siirtymisen merkki',
	'navigateMarkers': 'Siirrä merkit',
	'navNextMarker': 'Seuraava merkki',
	'navPrevMarker': 'Edellinen merkki',
	'navPrevMarkerAbbreviated': 'Ed. merkki',
	'timelineSettingsButton': 'Toistoasetukset',
	'autoPlay': 'Toista kaikki kohtaukset',
	'loop': 'Toista jatkuvasti',
	'refreshData': 'Päivitä käynnistettäessä',
	'slideshowLabel': 'Diaesitys',
	'panAndZoomLabel': 'Opastettu matka',
	'slideShowLayoutLabel': 'Diaesitys-asettelu',
	'panAndZoomLayoutLabel': 'Opastettu matka -asettelu',
	'panAndZoomLayoutFooter': 'Opastettu matka -asettelu on kokoelma kohtauksia yhdellä työalueella. Kun ajat tämäntyyppisen tarinan, esitys vierii ja zoomaa kuhunkin yksittäiseen kohtaukseen peräkkäisessä järjestyksessä. Tämä eroaa Diaesitys-asettelusta, jossa kukin kohtaus esitetään uudella työalueella. Opastettu matka -asettelu, jossa näkyy kolme viivoin yhdistettyä kohtausta, mahdollistaa vaakasuuntaisen kohtausjärjestyksen luonnin. Tämä on hyödyllinen esitysmuoto esimerkiksi aikajanalle.',
	'PanAndZoomLayout1': '5 kohtausta järjestettynä suorakulmaiseen muotoon',
	'PanAndZoomLayout2': '4 kohtausta järjestettynä portaikkomuotoon, joka kulkee ylöspäin vasemmalta oikealle',
	'PanAndZoomLayout3': '6 kohtausta järjestettynä suorakulmaiseen muotoon',
	'PanAndZoomLayout4': '7 kohtausta järjestettynä suorakulmaiseen muotoon, jossa on 6 pientä kohtausta ylhäällä ja yksi iso kohtaus alhaalla',
	'PanAndZoomLayout5': '3 kohtausta järjestettynä muotoon, jossa on 2 pientä kohtausta ylhäällä ja yksi iso kohtaus alhaalla',
	'PanAndZoomLayout6': '4 kohtausta järjestettynä vaakasuuntaisesti',
	'pageSelectWarning': 'Valitse kohtaus.',
	'noSceneTransitionLabel': 'Ei mitään',
	'sceneTransitionPropertyLabel': 'Kohtauksen siirto',
	'animatedPathSceneTransitionLabel': 'Animoitu polku',
	'sweepSceneTransitionLabel': 'Pyyhkäisy',
	'storyTypeLabel': 'Tarinatyyppi',
	'layoutLabel': 'Asettelu',
	'tabName_animation': 'Animaatio',
	'propAniAnimation': 'Animaatio',
	'propAniTypeEntrance': 'Aloitusanimaatio',
	'propAniDirectionIn': 'Aloituksen suunta',
	'propAniTypeExit': 'Lopetusanimaatio',
	'propAniDirectionOut': 'Lopetuksen suunta',
	'propAniDirection': 'Suunta',
	'propAniEntrance': 'Saapuminen',
	'propAniTypeEntranceSlideIn': 'Liu\'utus sisään',
	'propAniTypeEntranceFadeIn': 'Alkuhäivytys',
	'propAniTypeEntrancePivotIn': 'Kääntö sisään',
	'propAniTypeEntranceScaleIn': 'Pienennys',
	'propAniTypeEntranceShrinkIn': 'Kutistus sisään',
	'propAniDirectionInLeft': 'Vasemmalta',
	'propAniDirectionInRight': 'Oikealta',
	'propAniDirectionInTop': 'Ylhäältä',
	'propAniDirectionInBottom': 'Alhaalta',
	'propAniExit': 'Lopeta',
	'propAniTypeExitSlideIn': 'Liu\'utus ulos',
	'propAniTypeExitFadeIn': 'Loppuhäivytys',
	'propAniTypeExitPivotOut': 'Kääntö ulos',
	'propAniTypeExitScaleIn': 'Suurennus',
	'propAniTypeExitExpandOut': 'Laajennus ulos',
	'propAniDirectionOutLeft': 'Vasemmalle',
	'propAniDirectionOutRight': 'Oikealle',
	'propAniDirectionOutTop': 'Ylös',
	'propAniDirectionOutBottom': 'Alas',
	'propAniEntranceTime': 'Aloitus (sekuntia):',
	'propAniExitTime': 'Lopetus (sekuntia):',
	'animationNoEntranceText': 'Aloitusanimaatio ei käynnisty, jos pienoisohjelma on kohtauksen alussa.',
	'animationNoExitText': 'Lopetusanimaatio ei käynnisty, jos pienoisohjelma on kohtauksen lopussa.',
	'propAniTypeDataEntrance': 'Tietojen aloitus',
	'propAniRevealDuration': 'Aloitusanimaatio kesto',
	'timelineAnimationProperties': 'Avaa animaation ominaisuudet',
	'scenesPropertiesSection': 'Kohtaukset',
	'editStoryCoachMarkTitle': 'Muokkaa tarinaa',
	'editStoryCoachMarkContents': 'Muokkaa tarinaa napsauttamalla kynäkuvaketta.',
	'addDataStoryCoachMarkContents': 'Vedä ja pudota tietoja tietonäytöstä tarinaan.',
	'expandSceneCoachmarkTitle': 'Avaa aikajana',
	'expandSceneCoachmarkContents': 'Voit animoida kohtauksen säätämällä objektin näkyvyyttä ajan ja keston perusteella.',
	'overviewCoachmarkTitle': 'Kohtausten yleiskuvaus',
	'overviewCoachmarkContents': 'Käytä kohtausten yleiskuvausta tarinan alussa ja lopussa näyttääksesi yleiskuvan kaikista kohtauksista. Voit vaihtaa kohtauksen paikkaa toisen kohtauksen kanssa napsauttamalla ja vetämällä kohtausta kohtausten yleiskuvauksessa. Voit myös näyttää tai piilottaa kohtausten yleiskuvauksen tarinan ominaisuuksissa.',
	'animatedPathCoachmarkTitle': 'Animoitu polku',
	'animatedPathCoachmarkContents': 'Voit animoida objektin kohtauksesta toiseen kopioimalla ensin objektin sisältämän kohtauksen. Sitten siirrä, kierrä tai muuta objektin kokoa uudessa kohtauksessa.',
	'propShowStoryOverviewFirstSlide': 'Näytä kaikki kohtaukset alussa',
	'propShowStoryOverviewLastSlide': 'Näytä kaikki kohtaukset lopussa',
	'storySceneSingleCountLabel': '1 kohtaus',
	'storySceneCountLabel': '%{count} kohtausta',
	'storySceneRangeCountLabel': 'Kohtaus %{index} / %{count}',
	'storySceneExpand': 'Avaa aikajana',
	'storySceneActionMenu': 'Aloita kohtausten asetusvalikko',
	'timelineRightContainerLabel': 'Aikajanan painikeohjausobjektien ryhmä',
	'timelineViewLabel': 'Aikajana',
	'timelineZoomFit': 'Zoomaa sopivaksi',
	'timelineZoomIn': 'Lähennä',
	'timelineZoomOut': 'Loitonna',
	'timelinePositionIndicator': 'aikajanan sijainnin ilmaisin sijainnissa %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'aikajanan sijainnin ilmaisin, siirrä vasemmalle sijaintiin %{position}',
	'timelinePositionIndicatorMoveRightTo': 'aikajanan sijainnin ilmaisin, siirrä oikealle sijaintiin %{position}',
	'sceneStart': 'Siirry kohtauksen alkuun %{position}',
	'sceneEnd': 'Siirry kohtauksen loppuun %{position}',
	'timelineHighlightTitle': 'Korostus',
	'addTimelineHighlight': 'Lisää korostus',
	'addSceneBtnTitle': 'Lisää uusi kohtaus oletusmallin avulla',
	'addSceneChevronBtnTitle': 'Valitse kohtauksen malli',
	'timelinePlay': 'Toista',
	'timelinePause': 'Keskeytä',
	'sceneNavigation': 'Kohtauksessa siirtyminen',
	'navNextScene': 'Seuraava kohtaus',
	'navPrevScene': 'Edellinen kohtaus',
	'navPrevSceneAbbreviated': 'Edell. kohtaus',
	'navExitFullScreen': 'Poistu koko näytön tilasta',
	'navToggleOverview': 'Vaihda yleiskuvausta',
	'rowNumber': 'Rivi %{number}',
	'overviewBtnLabel': 'Yleiskuvaus',
	'sceneListStart': 'Yleiskuvauksen alku',
	'sceneListEnd': 'Yleiskuvauksen loppu',
	'timelineLeftHandle': 'vasen kahva kohteelle %{name}',
	'timelineRightHandle': 'oikea kahva kohteelle %{name}',
	'timelineLeftHandleNoTitle': 'vasen kahva',
	'timelineRightHandleNoTitle': 'oikea kahva',
	'timelineMoveLeft': 'Siirrä %{object} vasemmalle',
	'timelineMoveRight': 'Siirrä %{object} oikealle',
	'timelineMoveWidget': 'Aikajana-pienoisohjelma on siirretty aikaan %{newStartTime}–%{newEndTime}',
	'timelineMoveWidgetStartTime': 'Aikajana-pienoisohjelman aloitusaika on siirretty aikaan %{newStartTime}',
	'timelineMoveWidgetEndTime': 'Aikajana-pienoisohjelman lopetusaika on siirretty aikaan %{newEndTime}',
	'timelineMoveWidgetDown': 'Aikajana-pienoisohjelmaa on siirretty alaspäin',
	'timelineMoveWidgetUp': 'Aikajana-pienoisohjelmaa on siirretty ylöspäin',
	'addSceneTitle': 'Lisää kohtaus',
	'blankSceneLayout': 'Tyhjä',
	'titleSceneLayout': 'Otsikko ja alaotsikko',
	'sceneLayout1': 'Otsikko ja tekstiä yhden visualisoinnin vieressä',
	'sceneLayout2': 'Otsikko ja yksi visualisointi',
	'sceneLayout3': 'Otsikko ja kaksi visualisointia',
	'sceneLayout4': 'Monitoiminen',
	'sceneLayout5': 'Ei otsikkoa,  tekstiä yhden visualisoinnin vieressä',
	'sceneLayout6': 'Monitoiminen 2 saraketta 2 riviä',
	'sceneLayout7': 'Monitoiminen 2 vasemmalla 1 oikealla',
	'sceneLayout8': 'Monitoiminen 1 vasemmalla 2 oikealla',
	'sceneLayout9': 'Monitoiminen 1 ylhäällä 2 alhaalla',
	'sceneLayout10': 'Monitoiminen 2 ylhäällä 1 alhaalla',
	'sceneLayout11': 'Monitoiminen 4 ylhäällä 1 alhaalla',
	'sceneLayout12': 'Monitoiminen 1 ylhäällä, 1 alhaalla vasemmalla, 2 saraketta 2 riviä yhden päällä oikealla',
	'titleWidgetPlaceholderText': 'Kirjoita otsikko tähän',
	'subtitleWidgetPlaceholderText': 'Kirjoita alaotsikko tähän',
	'createStoryViewTitle': 'Luo tarina',
	'defaultStoryName': 'Uusi tarina',
	'screenshot_label': 'Tarina %{title}',
	'screenshot_label_scene': 'Kohtaus %{sceneTitle} tarinasta %{title}',
	'filmstripHandleOpenLabel': 'Avaa kohtauksen valitsin',
	'filmstripHandleCloseLabel': 'Sulje kohtauksen valitsin'
});
